'use strict';

import { GLOBAL } from './Global';
import { KAM as KAM_PERMISSION_GROUPS } from '../PermissionsGroups';

const kam_permissions_list = [];

for (const [key, value] of Object.entries(KAM_PERMISSION_GROUPS)) {
  kam_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const KAM = {
  can: [
    ...GLOBAL.can,
    ...kam_permissions_list,
  ],
};

export {
  KAM,
};
